import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/api/common/navigation/data';
import { T } from '@angular/cdk/keycodes';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi
{
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    // private readonly _compactNavigation: FuseNavigationItem[] = JSON.parse(localStorage.getItem('userNavigation'));
    // private readonly _defaultNavigation: FuseNavigationItem[] = JSON.parse(localStorage.getItem('userNavigation'));
    // private readonly _futuristicNavigation: FuseNavigationItem[] = JSON.parse(localStorage.getItem('userNavigation'));
    // private readonly _horizontalNavigation: FuseNavigationItem[] = JSON.parse(localStorage.getItem('userNavigation'));

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                let data = localStorage.getItem('userNavigation') ? JSON.parse(localStorage.getItem('userNavigation')) : [];
                let idArr = [];
                data.forEach(res => {idArr.push(res.id)});
                this._defaultNavigation.forEach(defaultNavItem => {
                    if (idArr.indexOf(defaultNavItem.id) !== -1) {
                        defaultNavItem.hidden = () => false;
                        if (defaultNavItem?.children?.length) {
                            let currentNav = data.filter(ch => {
                                return ch.id === defaultNavItem.id;
                            });
                            defaultNavItem.children.forEach(res => {
                                currentNav && currentNav[0].children.forEach(result => {
                                    if (res.id === result.id) {
                                        res.hidden = () => false;
                                        if (res?.children?.length) {
                                            let childsChild = result && result.children ? result.children : [];
                                            res.children.forEach(child => {
                                                childsChild.forEach(resp => {
                                                    if (child.id === resp.id) {
                                                        child.hidden = () => false;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        }
                    }
                });

                this._compactNavigation.forEach(compactNavigation => {
                    if (idArr.indexOf(compactNavigation.id) !== -1) {
                        compactNavigation.hidden = () => false;
                        if (compactNavigation?.children?.length) {
                            let currentNav = data.filter(ch => {
                                return ch.id === compactNavigation.id;
                            });
                            compactNavigation.children.forEach(res => {
                                currentNav && currentNav[0].children.forEach(result => {
                                    if (res.id === result.id) {
                                        res.hidden = () => false;
                                        if (res?.children?.length) {
                                            let childsChild = result && result.children ? result.children : [];
                                            res.children.forEach(child => {
                                                childsChild.forEach(resp => {
                                                    if (child.id === resp.id) {
                                                        child.hidden = () => false;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        }
                    }
                });

                this._futuristicNavigation.forEach(defaultNavItem => {
                    if (idArr.indexOf(defaultNavItem.id) !== -1) {
                        defaultNavItem.hidden = () => false;
                        if (defaultNavItem?.children?.length) {
                            let currentNav = data.filter(ch => {
                                return ch.id === defaultNavItem.id;
                            });
                            defaultNavItem.children.forEach(res => {
                                currentNav && currentNav[0].children.forEach(result => {
                                    if (res.id === result.id) {
                                        res.hidden = () => false;
                                        if (res?.children?.length) {
                                            let childsChild = result && result.children ? result.children : [];
                                            res.children.forEach(child => {
                                                childsChild.forEach(resp => {
                                                    if (child.id === resp.id) {
                                                        child.hidden = () => false;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        }
                    }
                });

                this._horizontalNavigation.forEach(horizontalNavigation => {
                    if (idArr.indexOf(horizontalNavigation.id) !== -1) {
                        horizontalNavigation.hidden = () => false;
                        if (horizontalNavigation?.children?.length) {
                            let currentNav = data.filter(ch => {
                                return ch.id === horizontalNavigation.id;
                            });
                            horizontalNavigation.children.forEach(res => {
                                currentNav && currentNav[0].children.forEach(result => {
                                    if (res.id === result.id) {
                                        res.hidden = () => false;
                                        if (res?.children?.length) {
                                            let childsChild = result && result.children ? result.children : [];
                                            res.children.forEach(child => {
                                                childsChild.forEach(resp => {
                                                    if (child.id === resp.id) {
                                                        child.hidden = () => false;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        }
                    }
                });

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactNavItem.id ) {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === futuristicNavItem.id ) {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === horizontalNavItem.id ) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        compact   : cloneDeep(this._compactNavigation),
                        default   : cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation)
                    }
                ];
            });
    }
}
